import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UigExportTypes } from '../components.models';

@Component({
    selector: 'app-uig-export',
    templateUrl: './uig-export.component.html',
    styleUrls: ['./uig-export.component.scss'],
    standalone: false
})
export class UigExportComponent implements OnInit {

  exportMode: string = 'export';

  selectedExportType: string = UigExportTypes[UigExportTypes.csv];
  exportTypes: string[] = Object.values(UigExportTypes).filter(
    (value) => typeof value === 'string'
  ) as string[];

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {}

  onSubmit() {
    this.modal.close(this.exportMode === 'print' ? 'print': this.selectedExportType);
  }
}
